import { render, staticRenderFns } from "./PersonSelector.vue?vue&type=template&id=1cb5e6ae&"
import script from "./PersonSelector.vue?vue&type=script&lang=js&"
export * from "./PersonSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports